import { OnChange } from '@occc-app/design-system';

import { FormApi } from 'final-form';

import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';

import { TRANSACTION_FREQUENCY_DEFAULT } from './utils/configureFormInitialValues';
import {
  getIsTransactionFrequencyLimitSupported,
  shouldCloseSetLimitsSectionDueToTransactionLimit,
} from './utils/offer.utils';

import { minimumPurchaseApplicableOfferTypes } from '../../constants';
import { OfferConfigureFormValues, OfferConfigureFormValuesPaths, OfferType } from '../../types';

type OfferTypeWatcherProps = {
  form: FormApi<OfferConfigureFormValues>;
};

const clearAwardRestrictions = (form: FormApi<OfferConfigureFormValues>) => {
  form.mutators.setFieldValue(
    'awardRestrictions.isEnabled' satisfies OfferConfigureFormValuesPaths,
    false,
  );
  form.mutators.setFieldValue(
    'awardRestrictions.awards' satisfies OfferConfigureFormValuesPaths,
    [],
  );
};

const closeSetLimitsSection = (form: FormApi<OfferConfigureFormValues>) => {
  form.mutators.setFieldValue('awardCount.isEnabled', false);
};

const clearTransactionFrequencyLimit = (form: FormApi<OfferConfigureFormValues>) => {
  form.mutators.setFieldValue(
    'awardCount.transactionFrequency' satisfies OfferConfigureFormValuesPaths,
    TRANSACTION_FREQUENCY_DEFAULT,
  );
};

const clearMinimumPurchaseConstraint = (form: FormApi<OfferConfigureFormValues>) => {
  form.mutators.setFieldValue(
    'minimumPurchaseConstraints.isEnabled' satisfies OfferConfigureFormValuesPaths,
    false,
  );
  form.mutators.setFieldValue(
    'minimumPurchaseConstraints.items' satisfies OfferConfigureFormValuesPaths,
    [
      {
        countProductsBy: Constraint_Purchase_Threshold_Counting_Attribute.Quantity,
      },
    ],
  );
};

export const OfferTypeWatcher = ({ form }: OfferTypeWatcherProps) => {
  return (
    <OnChange name={'offerType' satisfies OfferConfigureFormValuesPaths}>
      {(offerType: OfferType | null) => {
        const formValues = form.getState().values;

        if (offerType === OfferType.ExternalFulfillment) {
          clearAwardRestrictions(form);
        }

        const shouldClose =
          shouldCloseSetLimitsSectionDueToTransactionLimit(offerType, formValues.awardCount) ||
          (offerType != null && !getIsTransactionFrequencyLimitSupported(offerType));
        if (shouldClose) {
          closeSetLimitsSection(form);
        }

        if (offerType != null && !getIsTransactionFrequencyLimitSupported(offerType)) {
          clearTransactionFrequencyLimit(form);
        }

        if (offerType != null && !minimumPurchaseApplicableOfferTypes.includes(offerType)) {
          clearMinimumPurchaseConstraint(form);
        }
      }}
    </OnChange>
  );
};
